import { AlertTriangle, Circle, Loader2, WifiOff } from 'lucide-react';
import { ArrowLeft } from 'lucide-react';
import { navigate } from '@/app/router';
import { EditorToolbar } from './EditorToolbar';
import { SAVE_STATE_COPY, isUnsafeToLoseState, type SaveState } from '../persistence/save-state';

const STATE_ICON: Partial<Record<SaveState, typeof Circle>> = {
  saving: Loader2,
  error: AlertTriangle,
  conflict: AlertTriangle,
  offline: WifiOff,
};

/** SPEC-007 SAVE-REQ-010/011 — one indicator, mapped from the real save state. */
function SaveStateBadge({ state, onRetry }: { state: SaveState; onRetry: () => void }) {
  const Icon = STATE_ICON[state];
  const dim = state === 'clean';
  return (
    <p
      role="status"
      className={`flex items-center gap-1.5 text-[11px] ${dim ? 'text-text-muted' : 'text-text-secondary'}`}
    >
      {Icon ? (
        <Icon size={11} className={state === 'saving' ? 'animate-spin' : undefined} aria-hidden />
      ) : state === 'dirty' ? (
        <Circle size={7} fill="currentColor" aria-hidden />
      ) : null}
      {SAVE_STATE_COPY[state]}
      {state === 'error' ? (
        <button
          type="button"
          onClick={onRetry}
          className="ml-1 underline decoration-dotted underline-offset-2 hover:text-text-primary"
        >
          Tentar novamente
        </button>
      ) : null}
    </p>
  );
}

export function EditorHeader({
  name,
  saveState,
  onRetry,
}: {
  name: string;
  saveState: SaveState;
  onRetry: () => void;
}) {
  const goBack = () => {
    if (
      !isUnsafeToLoseState(saveState) ||
      window.confirm('Este funil tem alterações não salvas ou não confirmadas. Sair do funil?')
    ) {
      navigate('/app');
    }
  };
  return (
    <header className="flex min-h-14 items-center gap-4 border-b border-border-subtle bg-surface px-4">
      <button
        type="button"
        onClick={goBack}
        aria-label="Voltar ao painel"
        className="rounded-sm p-2 text-text-secondary hover:bg-surface-2 hover:text-text-primary"
      >
        <ArrowLeft size={17} />
      </button>
      <div className="min-w-0">
        <h1 className="max-w-[260px] truncate text-sm font-semibold text-text-primary">{name}</h1>
        <SaveStateBadge state={saveState} onRetry={onRetry} />
      </div>
      <div className="ml-auto">
        <EditorToolbar />
      </div>
    </header>
  );
}
